export default __webpack_public_path__ + "static/media/megane-rs-colour-2.758dee7c.jpg";